import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.LOG}/summary-logs`;

async function search(payload) {
  const url = `${basePath}`;
  try {
    let response = await api.get(url, { params: payload });
    let treated = errorHandling.handleResponse(response, "logControlService.search");
    if (treated) return treated;
    return null;
  } catch (error) {
    errorHandling.cathError(error, "logControlService.search");
    return null;
  }
}

async function downloadPdf(payload) {
  const url = `${basePath}/pdf`;
  try {
    let response = await api.get(url, {
      params: payload,
      responseType: "arraybuffer",
    });

    if (response?.status === 200 && response?.data?.byteLength > 0) {
      return new Blob([response.data], { type: "application/pdf" });
    }

    return null;
  } catch (error) {
    errorHandling.cathError(error, "logControlService.downloadPdf");
    return null;
  }
}

async function downloadXls(payload) {
  const url = `${basePath}/xls`;
  try {
    let response = await api.get(url, {
      params: payload,
      responseType: "arraybuffer",
    });

    if (response?.status === 200 && response?.data?.byteLength > 0) {
      return new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    }

    return null;
  } catch (error) {
    errorHandling.cathError(error, "logControlService.downloadXls");
    return null;
  }
}

export const logControlService = {
  search,
  downloadPdf,
  downloadXls,
};
